import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  TimeSeriesScale,
  Title,
  Tooltip
} from 'chart.js'
import 'chartjs-adapter-moment'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import {
  getUserCount,
  getUserRegistrationCount
} from '../../../../utils/APIs/users'
import Moaltip from '../../../Utilities/Tooltip/'
import DateRangePicker from '../DateRangePicker'
import styles from '../Stats.module.css'
import { getDateRangeLabels } from '../utils'

ChartJS.register(
  TimeSeriesScale,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
)

const UserCounts = () => {
  const [registrations, setRegistrations] = useState([])
  const [totalUsers, setTotalUser] = useState(0)
  const [labels, setLabels] = useState([])
  const [data, setData] = useState(null)
  const [startDate, setStartDate] = useState(
    moment().subtract(30, 'days').toDate()
  )
  const [endDate, setEndDate] = useState(moment().toDate())
  const [scaleType, setScaleType] = useState('timeseries')

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top'
      },
      tooltip: {
        titleFont: {
          size: 18
        },
        bodyFont: {
          size: 24
        },
        padding: 12
      }
    },
    scales: {
      x: {
        stacked: true,
        type: scaleType,
        time: {
          unit: 'day'
        },
        ticks: {
          minRotation: 45,
          maxRotation: 45
        }
      },
      y: {
        stacked: true,
        ticks: {
          stepSize: 20
        }
      }
    }
  }

  useEffect(() => {
    loadData()
    handleLabels()
  }, [startDate, endDate])

  useEffect(() => {
    handleData()
  }, [registrations])

  const loadData = async () => {
    loadRegistrations()
    getTotal()
  }

  const loadRegistrations = async () => {
    const response = await getUserRegistrationCount(
      moment(startDate).toISOString(),
      moment(endDate).toISOString()
    )
    if (response && response.status === 200) {
      setRegistrations(response.data)
    }
  }

  const getTotal = async () => {
    const response = await getUserCount()
    if (response && response.status === 200) {
      setTotalUser(response.data.count)
    }
  }

  const handleLabels = () => {
    const dateLabels = getDateRangeLabels(startDate, endDate)
    setLabels(dateLabels)
  }

  const handleData = () => {
    setData({
      labels,
      datasets: [
        {
          label: 'New Users',
          data: registrations.map((each) => ({
            x: each._id,
            y: Math.round(each.count)
          })),
          backgroundColor: '#9e2a2b',
          pointStyle: false,
          stacked: true
        }
      ]
    })
  }

  if (labels.length <= 0 || data === null) {
    return (
      <div className={styles.wrapper}>
        <div className="flex items-center justify-center my-auto">
          <p className="animate-pulse">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <header className="flex items-center gap-2">
        <h2>Total User Counts | {totalUsers}</h2>
        <Moaltip>
          This chart shows daily new user registrations. Each bar represents the
          total count for that day. Hover for exact details.
        </Moaltip>
      </header>

      <Bar options={options} data={data} className="p-2" />
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        scaleType={scaleType}
        setScaleType={setScaleType}
        disabled
      />
    </div>
  )
}

export default UserCounts
